import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_H_C, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, TS_Checkbox } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import './Inbox_FilterMenu.scss';
import { InboxFilters, InboxFilters_LabelMap } from '@app/advisor-v5-shared';
import { ModuleFE_Inbox } from '../../modules/module-inbox/ModuleFE_Inbox.js';
export class Inbox_FilterMenu extends ComponentSync {
    //######################### Life Cycle #########################
    __onInboxFiltersUpdated = () => this.reDeriveState();
    deriveStateFromProps(nextProps, state) {
        state.activeFilters = ModuleFE_Inbox.activeFilters.get();
        return state;
    }
    //######################### Render #########################
    render() {
        return _jsxs(_Fragment, { children: [this.render_Header(), this.render_AllTasks(), this.render_Filters()] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'inbox-filter-menu__header', onClick: () => ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp), children: ["Filter View", _jsx(ICONS.advisor_v4_arrow.component, {})] });
    };
    render_AllTasks = () => {
        const filters = this.state.activeFilters;
        const checked = !filters.length || filters.length === InboxFilters.length;
        return _jsx(TS_Checkbox, { checked: checked, onCheck: () => ModuleFE_Inbox.activeFilters.set([]), children: "All Tasks" });
    };
    render_Filters = () => {
        const filters = this.state.activeFilters;
        return InboxFilters.map(filter => {
            const checked = filters.includes(filter);
            return _jsx(TS_Checkbox, { className: 'indent', checked: checked, onCheck: () => {
                    const newFilters = checked ? filters.filter(i => i !== filter) : [...filters, filter];
                    ModuleFE_Inbox.activeFilters.set(newFilters);
                    this.reDeriveState();
                }, children: InboxFilters_LabelMap[filter] }, filter);
        });
    };
}
//# sourceMappingURL=Inbox_FilterMenu.js.map